import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'invoiceNumber'
})

export class InvoiceNumberPipe implements PipeTransform
{
	transform(value: number): string
	{
		const transformValue = value.toString();
		return transformValue.substr(0, 4) + '-' + transformValue.substr(4, 2) + '-' + transformValue.substr(6);
	}
}



// WEBPACK FOOTER //
// ./src/app/pipes/invoice-number.pipe.ts